import { useCallback } from "react";
import type { Proposal } from "@/features/Dashboard";

export function useResourceForecast(proposals: Proposal[]) {
  const getProposalColor = useCallback(
    (proposalName: string) => {
      const proposal = proposals.find((p) => p.name === proposalName);
      if (!proposal) return "gray";

      switch (proposal.heatLevel) {
        case "cool":
          return "blue";
        case "warm":
          return "yellow";
        case "hot":
          return "orange";
        case "burning":
          return "red";
        default:
          return "gray";
      }
    },
    [proposals]
  );

  const getProposalByName = useCallback(
    (name: string) => {
      return proposals.find((p) => p.name === name);
    },
    [proposals]
  );

  return {
    getProposalColor,
    getProposalByName,
  };
}
